import { Link } from "react-router-dom";
import { Instagram, Facebook } from "lucide-react";
import { Wordmark } from "@/components/Logo";

const COLS = [
  ["Platform", [["/discover", "Discover"], ["/events", "Events"], ["/discover?tab=opportunities", "Opportunities"], ["/discover?tab=briefs", "Partnership briefs"], ["/valuation", "Valuation tool"], ["/map", "Partnership map"], ["/news", "News"], ["/awards", "Awards"]]],
  ["Company", [["/about", "About"], ["/how-it-works", "How it works"], ["/faq", "FAQ"], ["/contact", "Contact"], ["/app/promote", "Advertise"]]],
  ["Legal", [["/privacy", "Privacy Policy"], ["/terms", "Terms of Service"]]],
  ["Account", [["/login", "Sign in"], ["/register", "Join free"], ["/app/pipeline", "Pipeline"], ["/app/payments", "Payments"]]],
];

export default function Footer() {
  return (
    <footer className="border-t border-[#2A1240]/10 bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Wordmark />
          <p className="mt-5 max-w-sm text-sm text-slate-400 leading-relaxed">
            The international partnership network for brands, sponsors, events, creators and agencies. Discover, connect, negotiate and manage partnerships in one place.
          </p>
          <div className="mt-5 flex items-center gap-3 text-sm text-slate-300" data-testid="footer-socials">
            <span>Follow us:</span>
            <a href="https://www.instagram.com/balqisbook" target="_blank" rel="noopener noreferrer" aria-label="Balqis Book on Instagram" className="inline-flex items-center gap-1.5 rounded-full border border-[#2A1240]/15 bg-white px-3 py-1.5 hover:border-[#E0218A] hover:text-[#E0218A]" data-testid="footer-instagram"><Instagram className="h-4 w-4" />@balqisbook</a>
            <a href="https://www.facebook.com/BalqisBook" target="_blank" rel="noopener noreferrer" aria-label="Balqis Book on Facebook" className="inline-flex items-center gap-1.5 rounded-full border border-[#2A1240]/15 bg-white px-3 py-1.5 hover:border-[#E0218A] hover:text-[#E0218A]" data-testid="footer-facebook"><Facebook className="h-4 w-4" />@BalqisBook</a>
          </div>
        </div>
        <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-8 text-sm">
          {COLS.map(([title, links]) => (
            <div key={title} className="space-y-3">
              <p className="kicker">{title}</p>
              {links.map(([to, label]) => (
                <Link key={to} to={to} className="block text-slate-300 hover:text-[#E0218A]" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>{label}</Link>
              ))}
            </div>
          ))}
        </div>
      </div>
      <div className="mx-auto max-w-7xl px-5 sm:px-8 pb-10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-slate-400">
        <span>© {new Date().getFullYear()} Balqis Book. All rights reserved.</span>
        <span>Questions? <a href="mailto:legal@balqisbook.com" className="underline">legal@balqisbook.com</a> · <a href="mailto:privacy@balqisbook.com" className="underline">privacy@balqisbook.com</a></span>
      </div>
    </footer>
  );
}
